import useConfigStore from '@/store/configStore';
import { TradingModal } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: (isOpen: boolean) => void;
};

export default function ReportIssueModal({ onClose }: Props) {
  const { t } = useTranslation();
  const envs = useConfigStore((state) => state.environmentSettings);

  return (
    <TradingModal
      open
      onClose={() => onClose(false)}
      titleText={t('reportIssueModal.title')}
      bodyText={
        <span>
          {t('reportIssueModal.message')} <a href={`mailto:${envs?.ISSUE_EMAIL}`}>{envs?.ISSUE_EMAIL}</a>
        </span>
      }
    />
  );
}
